import { forwardRef, type Ref, type SVGProps } from "react";
const IconMousePointerOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M25.38 16.86 10.3 2.52A2 2 0 0 0 7 4v21a2 2 0 0 0 .89 1.66 1.93 1.93 0 0 0 1.86.15L14 23.16l2.16 5.05a3 3 0 0 0 1.63 1.59 3.1 3.1 0 0 0 1.07.2 2.8 2.8 0 0 0 1.14-.25 3 3 0 0 0 1.52-3.89l-2.17-5.08 5.18-.58.29-.08a2 2 0 0 0 .56-3.26m-9 2.23 3.23 7.55a1 1 0 0 1-.49 1.28.94.94 0 0 1-.7 0 1 1 0 0 1-.52-.52l-3.2-7.55L9 25V4l15 14Z" />
  </svg>
);
const ForwardRef = forwardRef(IconMousePointerOutlineSVG);
ForwardRef.displayName = "IconMousePointerOutline";
export { ForwardRef as IconMousePointerOutline };
